export default "__VITE_ASSET__630f3806__"